// src/components/WorkCategoryManageModal.jsx
import React, { useEffect, useState } from "react";
import api from "../api";

export default function WorkCategoryManageModal({ isOpen, onClose, onChanged }) {
  const [categories, setCategories] = useState([]);
  const [newName, setNewName] = useState("");
  const [loading, setLoading] = useState(false);

  const fetchCategories = () => {
    api
      .get("/calendar/work-categories-manage/")
      .then((res) => setCategories(res.data || []))
      .catch((err) => console.error("항목 목록 불러오기 실패", err));
  };

  useEffect(() => {
    if (isOpen) {
      fetchCategories();
      setNewName("");
    }
  }, [isOpen]);

  const handleAdd = async () => {
    const name = newName.trim();
    if (!name) { alert("항목 이름을 입력하세요."); return; }
    if (categories.some((c) => c.name === name)) { alert("이미 존재하는 항목입니다."); return; }
    setLoading(true);
    try {
      await api.post("/calendar/work-categories-manage/", { name, is_active: true });
      setNewName("");
      fetchCategories();
      onChanged?.();
    } catch (err) {
      alert(err?.response?.data?.detail || "추가 실패 (권한을 확인하세요)");
    } finally {
      setLoading(false);
    }
  };

  const handleToggle = async (cat) => {
    try {
      await api.patch(`/calendar/work-categories-manage/${cat.id}/`, { is_active: !cat.is_active });
      fetchCategories();
      onChanged?.();
    } catch (err) {
      alert(err?.response?.data?.detail || "변경 실패 (권한을 확인하세요)");
    }
  };

  if (!isOpen) return null;

  return (
    <div style={{
      position: "fixed", top: 0, left: 0, width: "100%", height: "100%",
      backgroundColor: "rgba(0,0,0,0.5)", display: "flex",
      alignItems: "center", justifyContent: "center", zIndex: 1100,
    }}>
      <div style={{
        background: "#fff", borderRadius: "8px",
        boxShadow: "0 8px 32px rgba(0,0,0,0.2)",
        width: "360px", maxHeight: "80vh", overflowY: "auto",
        padding: "20px", boxSizing: "border-box",
        fontFamily: '"맑은 고딕", "Malgun Gothic", sans-serif', color: "#000",
      }}>
        {/* 헤더 */}
        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "16px" }}>
          <h3 style={{ margin: 0, fontSize: "16px", whiteSpace: "nowrap", flex: 1 }}>
            업무 항목 관리
          </h3>
          <button 
            onClick={onClose} 
            type="button"
            style={{ 
              border: "none", 
              background: "transparent", 
              fontSize: "22px", 
              cursor: "pointer", 
              color: "#666",
              width: "32px",       /* ✅ 버튼의 가로 영역을 제한 */
              height: "32px",      /* ✅ 세로 영역도 제한 */
              display: "flex",     /* ✅ 엑스표 중앙 정렬용 */
              alignItems: "center",
              justifyContent: "center",
              padding: 0,          /* ✅ 브라우저 기본 패딩 제거 */
              lineHeight: 1
            }}
          >
            ×
          </button>
        </div>


        {/* 추가 입력줄 — table로 확실하게 */}
        <table style={{ width: "100%", borderCollapse: "collapse", marginBottom: "16px" }}>
          <tbody>
            <tr>
              <td style={{ paddingRight: "8px" }}>
                <input
                  type="text"
                  value={newName}
                  onChange={(e) => setNewName(e.target.value)}
                  placeholder="새 항목 이름"
                  onKeyDown={(e) => { if (e.key === "Enter") handleAdd(); }}
                  style={{
                    display: "block", width: "100%", boxSizing: "border-box",
                    padding: "8px 12px", border: "1px solid #ddd",
                    borderRadius: "6px", fontSize: "14px", outline: "none",
                  }}
                />
              </td>
              <td style={{ width: "60px", whiteSpace: "nowrap" }}>
                <button onClick={handleAdd} disabled={loading} type="button"
                  style={{
                    display: "block", width: "60px",
                    padding: "8px 0", border: "none",
                    background: "#1a73e8", color: "#fff",
                    borderRadius: "6px", cursor: "pointer",
                    fontSize: "14px", fontWeight: 500,
                  }}>
                  추가
                </button>
              </td>
            </tr>
          </tbody>
        </table>

        {/* 목록 */}
        <div style={{ marginBottom: "16px" }}>
          {categories.length === 0 && (
            <div style={{ color: "#999", fontSize: "13px", textAlign: "center", padding: "12px 0" }}>
              항목이 없습니다.
            </div>
          )}
          {categories.map((cat) => (
            <table key={cat.id} style={{ width: "100%", borderCollapse: "collapse", marginBottom: "6px", border: "1px solid #eee", borderRadius: "6px" }}>
              <tbody>
                <tr>
                  <td style={{ padding: "8px 12px", fontSize: "14px", color: cat.is_active ? "#333" : "#aaa" }}>
                    {cat.name}
                    {!cat.is_active && (
                      <span style={{ marginLeft: "6px", fontSize: "11px", color: "#fff", background: "#bbb", borderRadius: "8px", padding: "1px 6px" }}>
                        숨김
                      </span>
                    )}
                  </td>
                  <td style={{ width: "60px", padding: "8px 12px", textAlign: "right", whiteSpace: "nowrap" }}>
                    <button onClick={() => handleToggle(cat)} type="button"
                      style={{
                        display: "inline-block", width: "56px",
                        padding: "4px 0",
                        border: `1px solid ${cat.is_active ? "#e0e0e0" : "#1a73e8"}`,
                        background: "#fff",
                        color: cat.is_active ? "#777" : "#1a73e8",
                        borderRadius: "6px", cursor: "pointer", fontSize: "12px",
                      }}>
                      {cat.is_active ? "숨기기" : "보이기"}
                    </button>
                  </td>
                </tr>
              </tbody>
            </table>
          ))}
        </div>

        {/* 완료 버튼 */}
        <div style={{ display: "flex", justifyContent: "flex-end" }}>
          <button onClick={onClose} type="button"
            style={{
              display: "inline-block", width: "auto",
              padding: "8px 20px", border: "none",
              background: "#1a73e8", color: "#fff",
              borderRadius: "6px", cursor: "pointer",
              fontSize: "14px", fontWeight: 500,
            }}>
            완료
          </button>
        </div>
      </div>
    </div>
  );
}